module.exports = __webpack_public_path__ + "static/media/gado_chan.cb1fbde1.png";